export const getPackagingReferrerLabel = (referrer: string) => {
  if (referrer.startsWith('/sold-goods/reports/')) {
    return 'Back to report';
  }
  if (referrer.startsWith('/sold-goods')) {
    return 'Back to packaging';
  }
  if (referrer.startsWith('/company-reports')) {
    return 'Back to company report';
  }

  return 'Back';
};

export const getFoodReferrerLabel = (referrer: string) => {
  if (referrer.startsWith('/sold-goods/reports/')) {
    return 'Back to report';
  }
  if (referrer.startsWith('/sold-goods')) {
    return 'Back to food and drink';
  }
  if (referrer.startsWith('/company-reports')) {
    return 'Back to company report';
  }

  return 'Back';
};
